import React from 'react';
import PropTypes from 'prop-types';

import StopStatusLog from 'modules/journey/stop-status-log';

const StopStatusCell = ({ journeyId, stopId }) => {
  return <StopStatusLog journeyId={journeyId} stopId={stopId} actionSource="LIST" />;
};

StopStatusCell.propTypes = {
  stopId: PropTypes.number.isRequired,
  journeyId: PropTypes.number.isRequired,
};

export default StopStatusCell;
